module.exports = __webpack_public_path__ + "media/images/countrysquared/by-4526e85e50240ab04488718cf93033a9.svg";